import { Button } from '@mantine/core'

export const CSVExportButton = ({ data, fileName }: { data: any[]; fileName: string }) => {
  const downloadCSV = (data: any[]) => {
    if (data.length === 0) {
      return
    }
    const headers = Object.keys(data[0]).join(',') + '\n'
    const rows = data
      .map((row) =>
        Object.values(row)
          .map((value) => `"${value ? value : ''}"`)
          .join(',')
      )
      .join('\n')

    const csvContent = headers + rows
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div
      style={{
        paddingRight: 10,
        paddingTop: 2,
      }}
    >
      <Button size='xs' right={'true'} mr={'md'} onClick={() => downloadCSV(data)}>
        Export CSV
      </Button>
    </div>
  )
}
